import CommandIdEnum from "../enums/CommandIdEnums";
import CommandStack from "../logic/CommandStack";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import ISceneObject from "../model/sceneObject/ISceneObject";
import { useServicesState } from "../store/servicesStateStore";
import { captureScreenshotBlob } from "../utils/screenshotUtils";
import GeometryFreeMoveCmd from "./GeometryFreeMoveCmd";

/**
 * Same behavior as GeometryFreeMoveCmd, but refreshes the checklist item's
 * stored screenshot after a successful move so it doesn't keep showing the
 * item's previous location.
 */
export default class ChecklistFreeMoveCmd extends GeometryFreeMoveCmd {

    constructor(
        commandStack: CommandStack,
        canvasInputListener: ICanvasInputListener,
        document: Document,
    ) {
        super(commandStack, canvasInputListener, document);
        this.id = CommandIdEnum.ChecklistFreeMove;
    }

    override async updateEntity(sceneObject: ISceneObject): Promise<boolean> {
        const success = await super.updateEntity(sceneObject);
        if (success) {
            await this.refreshScreenshot(sceneObject);
        }
        return success;
    }

    private async refreshScreenshot(sceneObject: ISceneObject): Promise<void> {
        const blob = await captureScreenshotBlob();
        if (!blob) {
            console.error("ChecklistFreeMoveCmd: failed to capture screenshot after move.");
            return;
        }

        const filename = `checklist-item-${Date.now()}.png`;
        const imageUrl = await useServicesState.getState().dataProvider
            ?.uploadChecklistItemImage(sceneObject.data.uuid, blob, filename) ?? null;

        if (!imageUrl) {
            console.error("ChecklistFreeMoveCmd: failed to upload updated screenshot.");
            return;
        }

        window.parent.postMessage(
            { type: 'CHECKLIST-ITEM-UPDATED', data: { uuid: sceneObject.data.uuid, imageUrl } },
            '*'
        );
    }
}
